import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.article`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);

    @media screen and (min-width: ${breakpoints.xl}) {
        row-gap: var(--spacing-3);
    }

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-2);
        }
    }
`;

export const Group = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);
    width: 100%;
`;

export const DisclosureBody = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-5);
    padding: var(--spacing-3);

    h4 {
        margin-bottom: calc(var(--spacing-3) / 2);
    }

    @supports not (padding-inline: 0) {
        & > div:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-5);
        }
    }
`;

export const IconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
`;
